import React from 'react';

export type CountryCode = 'SA' | 'PK' | 'LB' | 'QA' | 'TN';
export type Country = CountryCode;



const theme: any = () => {
    try {
        var themeData: any = localStorage.getItem("themes");
        return JSON.parse(themeData);
    }
    catch (e) {
        console.log(e);
        localStorage.removeItem("themes");
        window.location.reload();
    }
}




export const themes: any = theme





/*  {

    partner: {
        name: 'Edfapay',
        nameAR: "ادفع باي ",
        hostname: "https://pay.edfapay.com",
        mainDarkColorhexa: '#001b11',
        mainDarkColorRgba: 'rgb(0, 27, 17)', // 'rgb(16, 49, 43)' 
        MainGreenColorHexa: '#00e6a0',
        MainGreenColorRgba: 'rgb(0, 230, 160)',
        MainGreenColorHoverRgba: 'rgba(0, 230, 160 , .27)',
        loginPagelogo: 1,
        currencyEn1: "SAR",
        currencyAr1: "ريال",
        currencyEn2: "USD",
        currencyAr2: " دولار  ",
        AvailbelCountry: () => { const SAAvialablePhoneCountry: Country[] = ['SA']; return SAAvialablePhoneCountry },
        defaultCountry: () => { const SADefaultCountry: Country | any = 'SA'; return SADefaultCountry },
        StartPhoneNum: "+966",
        projects: {
            softPos: true,
            paymentGateway: true,
            invoicing: true
        }
    },
    Paysys: {
         name: 'Paysys',
         nameAR: "ادفع باي ",
         hostname:"https://pay.edfapay.com" ,
         mainDarkColorhexa: '#10312B',
         mainDarkColorRgba: 'rgb(16, 49, 43)',
         MainGreenColorHexa: '#00e6a0',
         MainGreenColorRgba: 'rgb(0, 230, 160)',
         loginPagelogo: 1,
         currencyEn1: " PKR ",
         currencyAr1: " روبيا  ",
         currencyEn2: "USD",
         currencyAr2: " دولار  ",
         AvailbelCountry: () => { const PKAvialablePhoneCountry: Country[] = ['PK']; return PKAvialablePhoneCountry },
         defaultCountry: () => { const PKDefaultCountry: Country | any = 'PK'; return PKDefaultCountry },
         StartPhoneNum: "+92",
         projects: {
             softPos: true,
             paymentGateway: false,
             Invoicing: false
         }
     },
     montyPay: {
         name: 'MontyPay',
         nameAR: "مونتي باي ",
         hostname:"https://pay.edfapay.com" ,
         mainDarkColorhexa: '#0076cf',
         mainDarkColorRgba: 'rgb(0, 118, 207)',
         MainGreenColorHexa: '#2edff1',
         MainGreenColorRgba: 'rgb(46, 223, 241)',
         MainGreenColorHoverRgba: 'rgba(0, 230, 160 , .27)',
         loginPagelogo: 2,
         currencyEn1: " USD ",
         currencyAr1: " دولار  ",
         currencyEn2: "LEB",
         currencyAr2: " ليرة  ",
         AvailbelCountry: () => { const LBAvialablePhoneCountry: Country[] = ['LB']; return LBAvialablePhoneCountry },
         defaultCountry: () => { const LBDefaultCountry: Country = 'LB'; return LBDefaultCountry },
         StartPhoneNum: "+961",
         projects: {
             softPos: true,
             paymentGateway: false,
             Invoicing: false
         }
     },
     MUME: {
         name: 'MUME',
         nameAR: " مـــومــي  ",
         hostname:"https://pay.edfapay.com" ,
         mainDarkColorhexa: '#272727',
         mainDarkColorRgba: 'rgb(39, 39, 39)',
         MainGreenColorHexa: '#29ff9c',
         MainGreenColorRgba: 'rgb(41, 255, 156)',
         MainGreenColorHoverRgba: 'rgba(41, 255, 156, .27)',
         loginPagelogo: 1,
         currencyEn1: "QAR",
         currencyAr1: "ريال",
         currencyEn2: "USD",
         currencyAr2: " دولار  ",
         AvailbelCountry: () => { const SAAvialablePhoneCountry: Country[] = ['QA']; return SAAvialablePhoneCountry },
         defaultCountry: () => { const SADefaultCountry: Country | any = 'QA'; return SADefaultCountry },
         StartPhoneNum: "+974",
         projects: {
             softPos: true,
             paymentGateway: false,
             invoicing: false
         }
     },
     weSettle: {
         //name: 'We-Settle',
         name: "WePay",
         nameAR: " وي سيتل ",
         hostname:"https://pay.edfapay.com" ,
         mainDarkColorhexa: '#473E6C',
         mainDarkColorRgba: 'rgb(71, 62, 108)',// 'rgb(16, 49, 43)' ,
         MainGreenColorHexa: "#1fb6c2",
         MainGreenColorRgba: 'rgb(31,182,194)',
         MainGreenColorHoverRgba: 'rgba(0, 31,182,194)',
         loginPagelogo: 1,
         currencyEn1: "TND",
         currencyAr1: "دينار",
         currencyEn2: "USD",
         currencyAr2: " دولار  ",
         AvailbelCountry: () => { const SAAvialablePhoneCountry: Country[] = ['TN']; return SAAvialablePhoneCountry },
         defaultCountry: () => { const SADefaultCountry: Country | any = 'TN'; return SADefaultCountry },
         StartPhoneNum: "+216",
         projects: {
             softPos: true,
             paymentGateway: true,
             invoicing: true
         }
     },

} */

const ThemeContext = React.createContext(themes?.partner);


export default ThemeContext;


